const translation: Record<string, string> = {
  // Navbar
  "nav.home": "Главная",
  "nav.categories": "Категории",
  "nav.about": "О нас",
  "nav.contact": "Контакты",
  "nav.select_category": "Выберите категорию",

  // Hero
  "hero.title_line1": "Yoybuy Sheet",
  "hero.title_line2": "Дешёвые товары из Китая в 2026",
  "hero.subtitle": "Сравнивайте цены, находите трендовые товары и экономьте до 70% через проверенные spreadsheet-таблицы",
  "hero.cta_primary": "Yoybuy Sheet",
  "hero.cta_secondary": "Buy It Now",

  // Stats
  "stats.savings": "Экономия",
  "stats.categories_count": "Категорий",
  "stats.products": "Товаров",
  "stats.updates": "Обновлений в день",

  // Categories
  "categories.title": "Категории товаров",
  "categories.subtitle": "Выбирайте из 14 проверенных категорий и находите лучшие предложения",
  "categories.on_site": "На kaspreadsheet.com",

  // Category Names
  "cat.shoes": "Обувь",
  "cat.hoodies": "Худи и Свитера",
  "cat.tshirts": "Футболки",
  "cat.jackets": "Куртки",
  "cat.pants": "Штаны и Шорты",
  "cat.headwear": "Головные уборы",
  "cat.sets": "Комплекты",
  "cat.underwear": "Нижнее бельё",
  "cat.jersey": "Джерси",
  "cat.accessories": "Аксессуары",
  "cat.bags": "Сумки",
  "cat.belts": "Ремни",
  "cat.perfumes": "Парфюмерия",
  "cat.other": "Разное",

  // Why Section
  "why.title": "Почему Spreadsheet",
  "why.subtitle": "Наша система поиска товаров экономит ваши деньги и время. Только проверенные продавцы и актуальные цены.",
  "why.card1_title": "Экономия до 70%",
  "why.card1_desc": "Прямые ссылки на фабрики Taobao, 1688 и Weidian без посредников и лишних наценок",
  "why.card2_title": "Обновления каждый день",
  "why.card2_desc": "Spreadsheet обновляется ежедневно — вы всегда видите актуальные цены и новинки",
  "why.card3_title": "Проверенные продавцы",
  "why.card3_desc": "Каждый продавец проходит ручную проверку перед добавлением в таблицу",

  // Trust Section
  "trust.quote": "Эти spreadsheet-таблицы полностью изменили мой подход к шопингу. Я нашла брендовые вещи по цене в 3-4 раза дешевле, чем в магазинах. Доставка быстрая, качество отличное!",
  "trust.name": "Анна М.",
  "trust.role": "Постоянный покупатель, Москва",
  "trust.button": "Читать отзывы",

  // SEO Preview
  "seo.label": "SEO Гайд",
  "seo.title_line1": "Yoybuy Sheet",
  "seo.title_line2": "Полное руководство 2026",
  "seo.summary": "Узнайте, как находить самые дешёвые товары из Китая через spreadsheet-таблицы. Пошаговое руководство по использованию yoybuy sheet: от поиска товаров до оформления заказа. Экономьте до 70% на каждой покупке с нашей системой проверенных ссылок.",
  "seo.read_more": "Читать статью →",

  // CTA Full
  "cta.title": "получить доступ к spreadsheet",
  "cta.description_line1": "Присоединяйтесь к тысячам покупателей,",
  "cta.description_line2": "которые уже экономят с yoybuy sheet",
  "cta.button": "Yoybuy Sheet",

  // Footer
  "footer.description": "Yoybuy Finds — ваш надёжный гид в мире китайского онлайн-шопинга. Мы собираем лучшие предложения и проверяем каждого продавца, чтобы вы покупали выгодно и безопасно.",
  "footer.address_line1": "Онлайн-платформа",
  "footer.address_line2": "Доступно по всему миру",
  "footer.phone": "Поддержка через сайт",
  "footer.email": "info@yoybuyfinds.lat",
  "footer.copyright": "© 2026 Yoybuy Finds. Все права защищены.",
  "footer.privacy": "Конфиденциальность",
  "footer.terms": "Условия",
  "footer.disclaimer": "Отказ от ответственности",

  // Article Page
  "article.back_home": "← На главную",
  "article.title": "Yoybuy Sheet: Полное руководство по поиску дешёвых товаров из Китая в 2026 году",
  "article.intro": "В мире онлайн-шопинга появился новый инструмент, который меняет правила игры — yoybuy sheet. Это не просто таблица с товарами, а целая система поиска лучших предложений на китайских маркетплейсах. В этом руководстве мы подробно разберём, как работает yoybuy sheet, почему он выгоднее AliExpress и как начать экономить уже сегодня.",
};

export default translation;